import { Button, DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Ewo, User } from '../../models';
import { apiClient, apiErrorMessage } from '../../utils';

export function EwoEditPage(props: { ewo?: Ewo; onSaved: (ewo?: Ewo) => void }) {
  const [users, setUsers] = useState<User[]>();
  const [usersLoading, setUsersLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const formValues: any = {
    ...props.ewo,
    whoId: props.ewo?.who?.id,
    routineWork: props.ewo?.routineWork ? 'true' : 'false',
    occuredAt: moment(props.ewo?.occuredAt),
  };

  useEffect(() => {
    apiClient
      .get('users')
      .then(response => {
        setUsers(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setUsersLoading(false);
      });
  }, []);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.ewo) {
      apiClient
        .post('ewos', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`ewos/${props.ewo?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={formValues}>
      <Form.Item
        label="Ne"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="what"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Ne zaman"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="when"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Tarih / saat"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="occuredAt"
      >
        <DatePicker showTime format="DD.MM.YYYY HH:mm" />
      </Form.Item>

      <Form.Item
        label="Nerede"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="where"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Kim"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="whoId"
      >
        <Select
          showSearch
          loading={usersLoading}
          filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {users?.map(u => (
            <Select.Option value={u.id}>{u.fullNameId}</Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Rutin çalışma" name="routineWork">
        <Select>
          <Select.Option key="true" value="true">
            Evet
          </Select.Option>
          <Select.Option key="false" value="false">
            Hayır
          </Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Hangi"
        rules={[
          {
            required: true,
            message: 'Zorunlu alan',
          },
        ]}
        name="which"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Nasıl"
        name="howDescription"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 4000, message: 'En fazla 4000 karakter' },
        ]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gönder
        </Button>
      </Form.Item>
    </Form>
  );
}
